/* ==========================================================================
   SCROLL REVEAL ANIMATIONS MODULE
   ========================================================================== */

export function initScrollAnimations() {
  const observerOptions = {
    threshold: 0.12,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  const animatedElements = document.querySelectorAll(
    '.service-card, .feature-card, .step-card, .case-card, .insight-card, .matrix-card, .contact-cta-banner'
  );

  animatedElements.forEach((el, index) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = `all 450ms cubic-bezier(0.16, 1, 0.3, 1) ${index % 4 * 80}ms`;
    observer.observe(el);
  });

  // Inject CSS class for revealed items
  const style = document.createElement('style');
  style.textContent = `
    .in-view {
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
  `;
  document.head.appendChild(style);
}
